export { default } from './ModulDescarregaApp';
